
/**
 * 구독 상태
 */
export type GetAdminUserSubscriptions200ResponseSubscriptionsItemStatus = typeof GetAdminUserSubscriptions200ResponseSubscriptionsItemStatus[keyof typeof GetAdminUserSubscriptions200ResponseSubscriptionsItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminUserSubscriptions200ResponseSubscriptionsItemStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  PENDING_BILLING_KEY: 'PENDING_BILLING_KEY',
  PAYMENT_FAILURE: 'PAYMENT_FAILURE',
  CANCELED_BY_USER: 'CANCELED_BY_USER',
  CANCELED_BY_ADMIN: 'CANCELED_BY_ADMIN',
  ON_HOLD: 'ON_HOLD',
  REGISTRATION_FAILURE: 'REGISTRATION_FAILURE',
  SUPERSEDED: 'SUPERSEDED',
} as const;
